<template>
  <nav class="pagination__bottom">
    <a href="" class="pagination__bottom--prev" v-on:click.prevent="setPreviousPage()" v-bind:disabled="isFirstPage() || loading.state" v-bind:title="$lang.pagination.prev_page">
      <i data-v-704e50d2="" aria-hidden="true" class="onp-chevron-left pagination__bottom--prev-arrow"></i> <span>{{ $lang.pagination.prev }}</span>
    </a>
    <a href="" class="pagination__bottom--next" v-on:click.prevent="setNextPage()" v-bind:disabled="isLastPage() || loading.state" v-bind:title="$lang.pagination.next_page">
      <span>{{ $lang.pagination.next }}</span> <i data-v-704e50d2="" aria-hidden="true" class="onp-chevron-right pagination__bottom--next-arrow"></i>
    </a>
    <ul class="pagination__bottom--list" v-if="appIsRunning">
      <li v-for="n in totalPagesNum">
        <a href="" v-if="isDisplayed(n)" v-on:click.prevent="setActivePage(n)" v-bind:class="[{ 'is-current': currentPage == n }]" class="pagination__bottom--list-link" v-bind:disabled="loading.state" v-bind:title="n"> {{ n }} </a>
        <span v-else-if="isDisplayedEllipsis(n)" class="pagination__bottom--list-span">&hellip;</span>
      </li>
    </ul>
  </nav>
</template>

<script>
// load shared methods from pagination module
import * as pagination from './../../scripts/modules/pagination'
import { mapGetters} from 'vuex'

export default {
  name: 'pagination',
  methods: {
    isFirstPage: function() {
      return pagination.isFirstPage()
    },
    isLastPage: function() {
      return pagination.isLastPage()
    },
    setPreviousPage: function() {
      return pagination.setPreviousPage()
    },
    setNextPage: function() {
      return pagination.setNextPage()
    },
    setActivePage: function(n) {
      return pagination.setActivePage(n)
    },
    isDisplayed: function(n) {
      return pagination.isDisplayed(n)
    },
    isDisplayedEllipsis: function(n) {
      return pagination.isDisplayedEllipsis(n)
    }
  },
  computed: {
    ...mapGetters({
      loading: 'GET_LOADING_STATE',
      totalPagesNum: 'GET_TOTAL_PAGES_NUM',
      currentPage: 'GET_CURRENT_PAGE',
      appIsRunning: 'GET_APP_IS_RUNNING'
    })
  }
}
</script>



// WEBPACK FOOTER //
// Pagination.vue?1bb0733c